import * as React from 'react'

import { useDeposit } from './hooks'
import { CButton, CCol, CRow } from '@coreui/react-pro'
import { path } from '../../../../libs'

export const DepositDetail = () => {
  const deposit = useDeposit()

  return (
    <div>
      <CRow>
        <CCol>
          <CButton
            color="primary"
            className="me-2"
            title={'Edit'}
            href={path.billing.deposit.edit(deposit.transactionId)}
          >
            Edit
          </CButton>
          <div className="mt-2">
            <span className="text-muted">isAuto:</span> {deposit.isAuto}
          </div>
          <div className="mt-2">
            <span className="text-muted">processingProvider:</span>{' '}
            {deposit.processingProvider}
          </div>
          <div className="mt-2">
            <span className="text-muted">processingMethod:</span>{' '}
            {deposit.processingMethod}
          </div>
          <div className="mt-2">
            <span className="text-muted">status:</span> {deposit.status}
          </div>
          <div className="mt-2">
            <span className="text-muted">initialAmount:</span>{' '}
            {deposit.initialAmount}
          </div>
          <div className="mt-2">
            <span className="text-muted">initialCurrency:</span>{' '}
            {deposit.initialCurrency}
          </div>
          <div className="mt-2">
            <span className="text-muted">clientAmount:</span>{' '}
            {deposit.clientAmount}
          </div>
          <div className="mt-2">
            <span className="text-muted">clientCurrency:</span>{' '}
            {deposit.clientCurrency}
          </div>
          <div className="mt-2">
            <span className="text-muted">clientCommission:</span>{' '}
            {deposit.clientCommission}
          </div>
          <div className="mt-2">
            <span className="text-muted">companyCommission:</span>{' '}
            {deposit.companyCommission}
          </div>
          <div className="mt-2">
            <span className="text-muted">commissionCurrency:</span>{' '}
            {deposit.commissionCurrency}
          </div>
          <div className="mt-2">
            <span className="text-muted">createdAt:</span> {deposit.createdAt}
          </div>
          <div className="mt-2">
            <span className="text-muted">updatedAt:</span> {deposit.updatedAt}
          </div>
          <div className="mt-2">
            <span className="text-muted">Client:</span>
            {deposit.client.clientId} {deposit.client.fullName}
            {deposit.client.email} {deposit.client.partner}
          </div>
          <div className="mt-2">
            <span className="text-muted">Manager:</span>
            {deposit.client.clientId} {deposit?.manager?.userId}
          </div>
        </CCol>
      </CRow>
    </div>
  )
}
